import { Controller } from "@hotwired/stimulus"
import { createConsumer } from "@rails/actioncable"

export default class extends Controller {
  static targets = ["banner", "offline", "player", "offlineMessage"]

  connect() {
    this.isLive = !this.hasBannerTarget || !this.bannerTarget.classList.contains("hidden")
    this.heartbeatTimer = null

    this.channel = createConsumer().subscriptions.create("StreamStatusChannel", {
      received: (data) => {
        this.updateStatus(data.is_live)
      }
    })

    if (this.isLive) {
      this.startHeartbeat()
    }
  }

  disconnect() {
    this.stopHeartbeat()
    if (this.channel) {
      this.channel.unsubscribe()
    }
  }

  updateStatus(isLive) {
    this.isLive = isLive

    if (this.hasBannerTarget) {
      this.bannerTarget.classList.toggle("hidden", !isLive)
    }
    if (this.hasOfflineTarget) {
      this.offlineTarget.classList.toggle("hidden", isLive)
    }
    if (this.hasPlayerTarget) {
      this.playerTarget.classList.toggle("hidden", !isLive)
    }
    if (this.hasOfflineMessageTarget) {
      this.offlineMessageTarget.classList.toggle("hidden", isLive)
    }

    if (isLive) {
      this.startHeartbeat()
    } else {
      this.stopHeartbeat()
    }
  }

  startHeartbeat() {
    if (this.heartbeatTimer) return
    this.heartbeatTimer = setInterval(() => {
      if (this.channel) {
        this.channel.perform("heartbeat")
      }
    }, 30000)
  }

  stopHeartbeat() {
    if (this.heartbeatTimer) {
      clearInterval(this.heartbeatTimer)
      this.heartbeatTimer = null
    }
  }
}
